import React from "react";
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table
} from '@material-ui/core';
import { upperCase } from "lodash";
export default class ComponentToPrint extends React.Component {

  render() {
    const balancePaymentListData = this.props.balancePaymentListData;
    const selectedSearchValues = this.props.selectedSearchValues;
    const selectedNewYear = this.props.selectedNewYear;
    const selectedNewMonth = this.props.selectedNewMonth;

    return (
      <div>
        <h2><center><u>Supplier Bank Details List</u></center></h2>
        <div>&nbsp;</div>
        <h3><center>BOUGHT LEAF DIRECT CHEQUE PAYMENT FOR THE MONTH OF {upperCase(selectedNewMonth)} - {selectedNewYear}</center></h3>
        <div>&nbsp;</div>
        <h3><center>Group: {selectedSearchValues.groupName}</center></h3>
        <h3><center>Factory: {selectedSearchValues.factoryName}</center></h3>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050} ml={2} mr={10} width="70%">
            <TableContainer style={{ padding: '0 20px', width: "100%", margin: "auto" }}>
              <div>
                <Table aria-label="caption table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell align={'center'} style={{ border: "0.5px solid grey" }}>Registration Number</TableCell>
                      <TableCell align={'center'} style={{ border: "0.5px solid grey" }}>Acc Holder Name</TableCell>
                      <TableCell align={'center'} style={{ border: "0.5px solid grey" }}>Account Number</TableCell>
                      <TableCell align={'center'} style={{ border: "0.5px solid grey" }}>Amount(Rs)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {balancePaymentListData.map((data, index) => (
                      <React.Fragment key={index}>
                        <TableRow key={index}>
                          <TableCell align={'left'} component="th" scope="row" style={{ border: "0.5px solid grey" }}>
                            {data.registrationNumber}
                          </TableCell>
                          <TableCell align={'left'} component="th" scope="row" style={{ border: "0.5px solid grey" }}>
                            {data.accountHolderName}
                          </TableCell>
                          <TableCell align={'left'} component="th" scope="row" style={{ border: "0.5px solid grey" }}>
                            {data.accountNumber}
                          </TableCell>
                          <TableCell align={'right'} component="th" scope="row" style={{ border: "0.5px solid grey" }}>
                            {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </TableContainer>
          </Box>
        </div>
        <div>&nbsp;</div>
        <h4><center>*******End of List*******</center></h4>
      </div>
    );

  }

}
